// @ts-nocheck;

import CodeMirror from 'codemirror';
import * as jsoncParser from 'jsonc-parser';

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : { 'default': e };
}

var CodeMirror__default = /*#__PURE__*/ _interopDefaultLegacy(CodeMirror);

var jsonDataTypeMarkerClass = 'codemirror-json-data-type-marker';

function onChange(cm, evt) {
  if (evt.origin == 'setValue') {
    cm.state.jsTypeMarker.initMarkerList();
    cm.state.jsTypeMarker.styleUpdate();
  } else {
    cm.state.jsTypeMarker.styleUpdate(cm.getCursor().line);
  }
}

function onUpdate(cm, evt) {
  if (!cm.state.jsTypeMarker.isUpdate) {
    cm.state.jsTypeMarker.isUpdate = true;
    cm.state.jsTypeMarker.initMarkerList();
    cm.state.jsTypeMarker.styleUpdate();
  }
}

function onRefresh(cm, evt) {
  onChange(cm, { origin: 'setValue' });
}

function onPaste(cm, evt) {
  onChange(cm, { origin: 'setValue' });
}

function hasClass(el, cls) {
  if (!el || !el.className) {
    return false;
  } else {
    var newClass = ' ' + el.className + ' ';
    return newClass.indexOf(' ' + cls + ' ') > -1;
  }
}

function CodeMirrorJsonDataTypeMarker(cm, opt) {
  this.opt = opt;
  this.cm = cm;

  this.markers = {};

  this.init();
}

CodeMirrorJsonDataTypeMarker.prototype.init = function () {
  this.cm.on('change', onChange);
  this.cm.on('update', onUpdate);
  this.cm.on('refresh', onRefresh);

  this.onPasteCallback = (function (cm, callback) {
    return function (evt) {
      callback.call(this, cm, evt);
    };
  })(this.cm, onPaste);

  this.cm.getWrapperElement().addEventListener('paste', this.onPasteCallback);
};

CodeMirrorJsonDataTypeMarker.prototype.destroy = function () {
  this.cm.off('change', onChange);
  this.cm.off('update', onUpdate);
  this.cm.off('refresh', onRefresh);

  this.cm.getWrapperElement().removeEventListener('paste', this.onPasteCallback);
};

CodeMirrorJsonDataTypeMarker.prototype.key = function (lineNo, ch) {
  return [lineNo, ch].join(':');
};

CodeMirrorJsonDataTypeMarker.prototype.initMarkerList = function () {
  this.markers = {};
};

CodeMirrorJsonDataTypeMarker.prototype.styleUpdate = function (lineNo) {
  var tree = jsoncParser.parseTree(this.cm.getValue());

  if (lineNo) {
    this.match(tree, lineNo, this.getLineNoOffset(lineNo));
  } else {
    var max = this.cm.lineCount();
    var offset = 0;

    for (var _lineNo = 0; _lineNo < max; _lineNo++) {
      this.match(tree, _lineNo, offset);
      offset += this.cm.getLine(_lineNo).length + 1;
    }
  }
};

CodeMirrorJsonDataTypeMarker.prototype.getLineNoOffset = function (lineNo) {
  var offset = 0;

  for (var i = 0; i < lineNo; i++) {
    offset += this.cm.getLine(i).length + 1;
  }

  return offset;
};

CodeMirrorJsonDataTypeMarker.prototype.emptyMarker = function (lineNo) {
  var lineHandle = this.cm.getLineHandle(lineNo);
  var list = lineHandle.markedSpans || [];

  for (var i = 0, len = list.length; i < len; i++) {
    var key = this.key(lineNo, list[i].from);

    if (key && hasClass(list[i].marker.replacedWith, jsonDataTypeMarkerClass)) {
      delete this.markers[key];
      list[i].marker.clear();
    }
  }
};

CodeMirrorJsonDataTypeMarker.prototype.getSchemaFromPath = function (propPath, defaultDataType) {
  if (!this.opt.schema || !propPath || !propPath.length) {
    return;
  }

  var schemaRef = this.opt.schema;
  var segmentIndex = 0;

  while (segmentIndex < propPath.length) {
    schemaRef = typeof schemaRef.children === 'function' ? schemaRef.children(propPath[segmentIndex]) : schemaRef.children && schemaRef.children[propPath[segmentIndex]];

    if (!schemaRef) {
      return;
    }

    segmentIndex++;
  }

  if (!this.opt.schemaCompatibilityValidator) {
    return schemaRef;
  }

  return this.opt.schemaCompatibilityValidator(schemaRef.type, defaultDataType) ? schemaRef : null;
};

CodeMirrorJsonDataTypeMarker.prototype.matchResult = function (tree, lineNo, offset) {
  var tokens = this.cm.getLineTokens(lineNo);

  return tokens.filter(function (token) {
    return token.type === 'string property';
  }).map(function (token) {
    var propNode = jsoncParser.findNodeAtOffset(tree, offset + token.start);

    if (!propNode) {
      return {
        property: token.string,
        render: false
      };
    }

    var propPath;

    try {
      propPath = jsoncParser.getNodePath(propNode);
    } catch (e) {}

    var defaultDataType = propNode.parent && propNode.parent.children[1] && propNode.parent.children[1].type;

    if (defaultDataType && this.opt.defaultDataTypesMapping) {
      defaultDataType = this.opt.defaultDataTypesMapping[defaultDataType] || defaultDataType;
    }

    var resolvedSchema = this.getSchemaFromPath(propPath, defaultDataType);

    var shouldRender = !!defaultDataType && (!this.opt.showCompound ? defaultDataType !== 'array' && defaultDataType !== 'object' : true);

    if (resolvedSchema && resolvedSchema.hideType) {
      shouldRender = false;
    }

    return {
      property: token.string,
      render: shouldRender,
      dataType: resolvedSchema && resolvedSchema.type || (!this.opt.hideDefaults ? defaultDataType : null)
    };
  }, this);
};

CodeMirrorJsonDataTypeMarker.prototype.subMatch = function (tree, lineNo, offset) {
  this.emptyMarker(lineNo);

  var result = this.matchResult(tree, lineNo, offset);

  var obj = {
    next: 0
  };

  result.forEach(function (item) {
    if (!item.render || !item.dataType) {
      return;
    }

    this.render(obj, lineNo, item.property, item.dataType);
  }, this);
};

CodeMirrorJsonDataTypeMarker.prototype.match = function (tree, lineNo, offset) {
  var self = this;

  this.cm.operation(function () {
    self.subMatch(tree, lineNo, offset);
  });
};

CodeMirrorJsonDataTypeMarker.prototype.makeElement = function () {
  var el = document.createElement('div');
  el.className = jsonDataTypeMarkerClass;
  return el;
};

CodeMirrorJsonDataTypeMarker.prototype.updateElement = function (el, dataType) {
  el.textContent = dataType;
};

CodeMirrorJsonDataTypeMarker.prototype.setState = function (lineNo, start, property, dataType) {
  var marker = this.createMarker(lineNo, start);

  marker.lineNo = lineNo;
  marker.ch = start;
  marker.property = property;
  marker.dataType = dataType;

  return marker;
};

CodeMirrorJsonDataTypeMarker.prototype.createMarker = function (lineNo, start) {
  if (!this.hasMarker(lineNo, start)) {
    this.initMarker(lineNo, start);
  }

  return this.getMarker(lineNo, start);
};

CodeMirrorJsonDataTypeMarker.prototype.initMarker = function (lineNo, start) {
  this.markers[this.key(lineNo, start)] = this.makeElement();
};

CodeMirrorJsonDataTypeMarker.prototype.hasMarker = function (lineNo, start) {
  return !!this.getMarker(lineNo, start);
};

CodeMirrorJsonDataTypeMarker.prototype.getMarker = function (lineNo, start) {
  var key = this.key(lineNo, start);
  return this.markers[key];
};

CodeMirrorJsonDataTypeMarker.prototype.setBookMark = function (line, ch, el) {
  this.cm.setBookmark({
    line: line,
    ch: ch
  }, {
    widget: el,
    handleMouseEvents: true,
    insertLeft: true
  });
};

CodeMirrorJsonDataTypeMarker.prototype.render = function (cursor, lineNo, property, dataType) {
  var lineHandle = this.cm.getLineHandle(lineNo);

  var start = lineHandle.text.indexOf(property, cursor.next);

  cursor.next = start + property.length;

  var el = this.createMarker(lineNo, start);
  this.updateElement(el, dataType);
  this.setState(lineNo, start, property, dataType);
  this.setBookMark(lineNo, start + property.length, el);
};

CodeMirror__default['default'].defineOption('jsonDataTypeMarker', false, function (cm, val, old) {
  if (old && old != CodeMirror__default['default'].Init) {
    if (cm.state.jsTypeMarker) {
      cm.state.jsTypeMarker.destroy();
      cm.state.jsTypeMarker = null;
    }
  }

  if (val) {
    cm.state.jsTypeMarker = new CodeMirrorJsonDataTypeMarker(cm, val);
  }
});
